<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <div class="modal-title">
    <h3 class="green decoration">Historial de asignaciones</h3>
  </div>
  <div class="modal-inner">
    <p class="m-0 mb-3"><strong>Activo:</strong> {{ data?.type }}<ng-container *ngIf="data?.model"> - {{ data?.model }}</ng-container><ng-container *ngIf="data?.cod_asset"> ({{ data?.cod_asset }})</ng-container></p>

    <p *ngIf="!loading && history.length == 0">Este activo todavía no tiene historial de asignaciones.</p>

    <table class="w-full not-wrap" *ngIf="history.length > 0">
      <thead>
        <tr>
          <th class="text-left">Comercio</th>
          <th class="text-left">Ubicación</th>
          <th class="text-left">Asignado</th>
          <th class="text-left">Condición de entrega</th>
          <th class="text-left">Devuelto</th>
          <th class="text-left">Estado en recojo</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of history">
          <td>{{ item.organization || '---' }}</td>
          <td>{{ item.branch_office || '---' }}</td>
          <td>{{ item.assigned_at || '---' }}</td>
          <td>{{ item.assigned_condition || '---' }}</td>
          <td>{{ item.returned_at || '---' }}</td>
          <td>{{ item.returned_condition || '---' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-end actions_modal">
    <button mat-button type="button" (click)="dismiss()" class="btn btn-primary big">Cerrar</button>
  </div>
</div>
